/** @file English catalog part of area E2 (W3-03); replaced whole by that area. */

/** The `forms` block (CommandForm, delete dialog, tree panels). S0 composes it into `en`. */
export const formsEn = {
  apply: 'Apply', set: 'Set {field}', invalidJson: 'Not valid JSON.', noProject: 'No project is open.',
  color: { pick: 'Pick a colour', alpha: 'Alpha' },
  delete: { one: 'Delete {name}?', many: 'Delete {n} items?', alsoRemoves: 'This also removes:' },
  kinds: {
    image: '{n} images', bone: '{n} bones', slot: '{n} slots', attachment: '{n} attachments', skin: '{n} skins',
    ik: '{n} IK constraints', event: '{n} events', socket: '{n} sockets', animation: '{n} animations', reference: '{n} references',
  },
} as const;
